<script setup lang="ts">
import { Copy01Icon } from '@gohighlevel/ghl-icons/24/outline'
import { UIModal, UIModalFooter, UIModalHeader } from '@gohighlevel/ghl-ui'

const props = defineProps({
  show: Boolean,
  headerTitle: String,
  disabledConfirm: Boolean,
})

const emit = defineEmits(['onConfirm', 'onModalClose', 'update:show'])

const handleSave = () => {
  emit('onConfirm')
}
const handleCancel = () => {
  emit('onModalClose')
}
</script>

<template>
  <UIModal
    id="deleteConfirmationModal"
    :show="show"
    @update:show="val => $emit('update:show', val)"
  >
    <template #header>
      <UIModalHeader
        id="deleteConfirmationModalHeader"
        type="primary"
        :title="headerTitle"
        :icon="Copy01Icon"
        @close="handleCancel"
      >
      </UIModalHeader>
    </template>

    <slot name="message" />

    <template #footer>
      <UIModalFooter
        id="deleteConfirmationModalFooter"
        type="primary"
        :positive-text="$t('settings.calendar.duplicate')"
        :negative-text="$t('settings.calendar.cancel')"
        :loading="disabledConfirm"
        :disabled="disabledConfirm"
        @positive-click="handleSave"
        @negative-click="handleCancel"
      />
    </template>
  </UIModal>
</template>
